
































import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    props: {
        icon: { type: String, required: true },
        status: { type: String, default: "" },
        statusCss: { type: String, default: "statusText" },
        paired: { type: Boolean as () => boolean | null, default: null },
        responsive: { type: Boolean as () => boolean | null, default: null },
        isConnecting: { type: Boolean as () => boolean, default: false }
    },
    setup(props) {
        const iconSrc = computed(() => {
            return require(`@/assets/icons/${props.icon}.svg`);
        });
        const withStatus = computed(() => {
            // Show the status area while connecting even if status text is empty
            return props.isConnecting || props.status !== "";
        });
        const statusColorClass = computed(() => {
            if (!props.paired) {
                return "whiteText";
            }
            return props.responsive ? "greenText" : "redText";
        });
        const displayStatus = computed(() => {
            if (!props.status) return "N/A";
            if (!props.responsive) return "N/A";
            if (props.isConnecting) return "Connecting...";
            // return props.responsive === false ? `(${props.status})` : props.status;
            return props.status;
        });

        return {
            iconSrc,
            statusColorClass,
            withStatus,
            displayStatus,
        };
    }
});
